;(function() {
  'use strict'

  angular.module('app.survey').filter('markdown', Filter)

  function Filter() {
    return function(string) {
      return window.marked(string)
    }
  }
})()
